import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { ImageViewport } from '../../../enums/image-viewports'

@Injectable({ providedIn: 'root' })
export class SmallHeaderConverter extends CmsConverterService<SmallHeaderData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const xl = CmsConverterService.getImageSize(formData.st_smaller_header_image_reference, ImageViewport.W4H1, 1170)
    const lg = CmsConverterService.getImageSize(formData.st_smaller_header_image_reference, ImageViewport.W3H1, 970)
    const md = CmsConverterService.getImageSize(formData.st_smaller_header_image_reference, ImageViewport.W2H1, 750)
    const sm = CmsConverterService.getImageSize(formData.st_smaller_header_image_reference, ImageViewport.W1H1, 768)
    const xs = CmsConverterService.getImageSize(formData.st_smaller_header_image_reference, ImageViewport.W1H1, 480)
    return {
      image: {
        xl,
        lg,
        md,
        sm,
        xs,
        altText: formData.st_smaller_header_alternative_text?.value ||
          formData.st_smaller_header_image_reference?.value?.[0]?.value?.target?.altTag || '',
        lazyLoad: formData.st_lazy_load_image?.value ?? true,
        mime: formData.st_slim_header_image_reference?.value?.[0]?.value?.target?.mime ?? '',
      },
      text: formData.st_smaller_header_image_text ?? defaultTextInput,
      overlay: {
        name: formData.st_smaller_header_image_overlay?.name ?? '',
        value: formData.st_smaller_header_image_overlay?.value?.identifier ?? '',
      },
      invertOverlay: formData.st_invert_overlay?.value ?? false,
    }
  }
}

export const SMALL_HEADER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, SmallHeaderData>>('SmallHeaderConverter')

export interface SmallHeaderData extends ConvertedComponentData {
  image: Image;
  text: TextInput;
  overlay: TextInput;
  invertOverlay: boolean;
}
